import { isRecord } from '@sweetistics/contracts/utils/type-guards';

export * from '@sweetistics/contracts/utils/type-guards';
export {
  isPromiseLike,
  toTrimmedNonEmptyStringOrUndefined as nonEmptyString,
} from '@sweetistics/contracts/utils/type-guards';

export type Present<T> = Exclude<T, null | undefined>;

export const isNullish = (value: unknown): value is null | undefined => value == null;

export const isPresent = <T>(value: T): value is Present<T> => !isNullish(value);

export function assertPresent<T>(value: T, message = 'Expected value to be present'): asserts value is Present<T> {
  if (!isPresent(value)) {
    throw new Error(message);
  }
}

const isFiniteNumber = (value: unknown): value is number => typeof value === 'number' && Number.isFinite(value);

const normalizeNumericCandidate = (value: unknown): number | undefined => {
  if (isFiniteNumber(value)) {
    return value;
  }

  if (typeof value === 'string' && value.trim().length > 0) {
    const parsed = Number(value);
    if (Number.isFinite(parsed)) {
      return parsed;
    }
  }

  return;
};

export function readNumericMetric(candidate: unknown, ...keys: readonly string[]): number | undefined {
  if (!isRecord(candidate)) {
    return;
  }

  for (const key of keys) {
    const value = normalizeNumericCandidate(candidate[key]);
    if (value !== undefined) {
      return value;
    }
  }

  return;
}
